import React from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { getProductBySlug } from "../../data/products";
import "./ProductDetail.css";

const ProductDetail = () => {
  const { productId } = useParams();
  const product = getProductBySlug(productId);

  if (!product) {
    return (
      <div className="product-detail-page">
        <div className="product-detail-container">
          <h1>Product not found</h1>
        </div>
      </div>
    );
  }

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.6, 0.05, 0.01, 0.99],
      },
    },
  };

  return (
    <div className="product-detail-page">
      <motion.div
        className="product-detail-container"
        initial="initial"
        animate="animate"
        variants={fadeIn}
      >
        <div className="product-detail-grid">
          <div className="product-image-section">
            <img src={product.image} alt={product.name} />
            {product.tag && <span className="product-tag">{product.tag}</span>}
          </div>

          <div className="product-info-section">
            <h1>{product.name}</h1>
            <p className="product-description">{product.fullDescription}</p>

            <div className="product-meta">
              <span className="product-volume">{product.volume}</span>
              <span className="product-price">${product.price}</span>
            </div>

            <div className="product-benefits">
              <h3>Key Benefits</h3>
              <ul>
                {product.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>

            <div className="product-ingredients">
              <h3>Ingredients</h3>
              <p>{product.ingredients}</p>
            </div>

            <button className="add-to-cart-btn">Add to Cart</button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ProductDetail;
